<template>
  <div class="mobile-text">
    {{ text }}
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'mobile-text',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style scoped>
.mobile-text{
  font-size: .875rem;
  color: #666;
  line-height: 1.125rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile-text/index.vue